var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('button',{class:("button floating btn--" + _vm.type),on:{"click":function($event){return _vm.emitCloseDialogEvent()}}},[_c('span',[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []

export { render, staticRenderFns }